import cn from 'classnames'
import { FC, useCallback, useMemo } from 'react'

import { Nullable } from 'clickNgo/models/utils'
import { FormNumberInput, useGetFormDataField } from 'cng-common/features/form'
import { ValidationType } from 'cng-common/features/form/configs'
import { Tooltip } from 'core-components/library/tooltip'

import { PARTNER_BASIC_INFO_FORM_KEY, partnerBasicInfoFields } from '../../../../../configs'

import { tooltipMessage } from './configs'

import styles from './OperatingProfitEditMode.module.scss'

interface IOperatingProfitEditModeProps {
  profit: Nullable<number>
  yoy: Nullable<number>
  profitTranslationKey?: string
  yoyTranslationKey?: string
}

export const OperatingProfitEditMode: FC<IOperatingProfitEditModeProps> = ({
  profit,
  yoy,
  profitTranslationKey: profitKey = '',
  yoyTranslationKey: yoyKey = '',
}) => {
  const [operationProfit] = useGetFormDataField<Nullable<number>>(
    PARTNER_BASIC_INFO_FORM_KEY,
    partnerBasicInfoFields.operationProfit
  )

  const isShowCompletenessWarning = useCallback((currentValue: Nullable<number>) => {
    return currentValue === null
  }, [])

  const handleValidateYoY = useCallback(async (yoyValue: Nullable<number>) => {
    if (yoyValue) {
      if (yoyValue < 0) {
        return 'YoY should not be lesser then 0'
      }

      if (yoyValue > 100) {
        return 'Yoy should not be greater then 100'
      }
    }

    return ''
  }, [])

  const tooltipRender = useCallback(() => {
    return <>{tooltipMessage}</>
  }, [])

  const isShowOperationProfitWarning = useMemo(
    () => isShowCompletenessWarning(operationProfit) && !operationProfit,
    [operationProfit, isShowCompletenessWarning]
  )

  return (
    <div className={styles.root}>
      <div className={styles.fieldWrapper}>
        <div className={styles.fieldInput}>
          <Tooltip disabled={!isShowOperationProfitWarning} tipContent={tooltipRender}>
            <FormNumberInput
              formKey={PARTNER_BASIC_INFO_FORM_KEY}
              field={partnerBasicInfoFields.operationProfit}
              label={profitKey}
              defaultValue={profit}
              className={cn({ [styles.warning]: isShowOperationProfitWarning })}
            />
          </Tooltip>
        </div>
      </div>
      <div className={styles.fieldWrapper}>
        <div className={styles.fieldInput}>
          <FormNumberInput
            formKey={PARTNER_BASIC_INFO_FORM_KEY}
            field={partnerBasicInfoFields.operationProfitYoY}
            label={yoyKey}
            defaultValue={yoy}
            onValidate={handleValidateYoY}
            validationType={ValidationType.ONCHANGE}
          />
        </div>
      </div>
    </div>
  )
}
